import { useNotificationsMobile } from "./notificationsMobile/useNotificationsMobile";
import { NotificationsMobileTopBar } from "./notificationsMobile/notificationsMobileTopBar";
import { FullScreenSpinner } from "@/components/fullScreenSpinner/FullScreenSpinner";
// eslint-disable-next-line max-len
import { NotificationListElement } from "@/components/notificationListElement/notificationListElement";

export function NotificationsMobile() {
  const { notifications, isLoading } = useNotificationsMobile();

  if (isLoading)
    return (
      <>
        <NotificationsMobileTopBar />
        <FullScreenSpinner />
      </>
    );

  return (
    <>
      <NotificationsMobileTopBar />
      <div className="flex flex-col gap-4 p-6 text-base">
        {notifications?.map((notification, index) => (
          <>
            <NotificationListElement
              type="mobile"
              notification={notification}
            />
            {index !== notifications.length - 1 && (
              <div className="bg-neutral h-px w-full" />
            )}
          </>
        ))}
      </div>
    </>
  );
}
